import React from 'react'
import { useUIStore } from '../../stores/ui-store'
import { trpc } from '../../lib/trpc'
import BrandKitTaskModal from '../kanban/BrandKitTaskModal'

export default function GlobalTaskCreationModal() {
  const { 
    showTaskCreationModal, 
    taskCreationColumnId,
    taskCreationKanbanId,
    taskCreationAssigneeId,
    taskCreationAssigneeName,
    closeTaskCreationModal 
  } = useUIStore()
  
  const { data: workspaces = [] } = trpc.workspace.list.useQuery()
  const activeWorkspace = workspaces[0]
  
  if (!activeWorkspace || !showTaskCreationModal) {
    return null
  }
  
  return (
    <BrandKitTaskModal
      open={showTaskCreationModal}
      onClose={closeTaskCreationModal}
      workspaceId={activeWorkspace.id}
      kanbanColumnId={taskCreationColumnId || undefined}
      assigneeId={taskCreationAssigneeId}
      assigneeName={taskCreationAssigneeName}
      onSuccess={() => {
        closeTaskCreationModal()
      }}
    />
  )
}